import checkoutApi from './CheckoutApi';
import configApi from './ConfigApi';
import insuranceApi from './InsuranceApi';
import paymentApi from './PaymentApi';
import pharmacyApi from './PharmacyApi';
import prescriptionApi from './PrescriptionApi';
import promoApi from './PromoApi';
import sessionApi from './SessionApi';
import subscriptionApi from './SubscriptionApi';
import userApi from './UserApi';
import OtpApi from './OtpApi';

export {
  checkoutApi,
  configApi,
  insuranceApi,
  paymentApi,
  pharmacyApi,
  prescriptionApi,
  promoApi,
  sessionApi,
  subscriptionApi,
  userApi,
  OtpApi,
};
